import { I18n } from "../services/I18n";
import "./generated/site-translations-sk";
import common_sk from "../../../../../libs/ps/restaumatic-common/locales/sk.json";
import core_types_sites_sk from "../../../../../libs/ps/restaumatic-core-types-sites/locales/sk.json";
I18n.translations = I18n.translations || {};
I18n.translations = I18n.extend(I18n.translations, {
  sk: { _core_types_sites: core_types_sites_sk },
});
I18n.translations = I18n.extend(I18n.translations, {
  sk: { _common: common_sk },
});
